import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, Switch } from '@homeexchange/design';
import { CurrencyFormatter } from '../../utils/Intl';
import Utils from '../../utils/utils';
import Subscription from '../../models/Subscription';
import i18n from '../../i18n';
import Product from '../../models/Product';

const Payment3x = ({
    updateIs3xPayment,
    is3xPaymentFromFinalization,
    updateIs3xPaymentFromFinalization,
    subProduct,
    subCurrency
}) => {
    const [isChecked, setChecked] = useState(false);

    const threeTimesPaymentPrice = Utils.getThreeTimesPaymentPrice(subProduct.price, subCurrency);

    useEffect(() => {
        if (/conversations\/([0-9]+)\/payment/.test(window.location.href)) {
            updateIs3xPaymentFromFinalization(isChecked);
        } else if (is3xPaymentFromFinalization === null) {
            updateIs3xPayment(isChecked);
        }
    }, [isChecked]);

    return (
        <div className="payment3x">
            <div className="payment3x-body">
                <div className="payment3x-header">
                    <div className="payment3x-header-title">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('subscription:price.increase.3xpayment.info_block.title', {
                                    threeTimesPaymentPrice,
                                    annualMembership: CurrencyFormatter.format(subProduct.price, subCurrency),
                                    serviceFeePrice: CurrencyFormatter.format(
                                        Subscription.EUROPE_SERVICE_CHARGE_PRICE,
                                        subCurrency
                                    )
                                })
                            }}
                        />
                    </div>
                    <div className="payment3x-header-switch">
                        <Switch onChange={setChecked} />
                    </div>
                </div>
                {isChecked && (
                    <div className="payment3x-content">
                        <p>{i18n.t('subscription:3xpayment.info_block.content')}</p>
                        <Link
                            href={i18n.t('url:url.3xpayment_option.learn_more')}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {i18n.t('common:learn_more')}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

Payment3x.propTypes = {
    updateIs3xPayment: PropTypes.func,
    is3xPaymentFromFinalization: PropTypes.bool,
    updateIs3xPaymentFromFinalization: PropTypes.func,
    subProduct: PropTypes.instanceOf(Product),
    subCurrency: PropTypes.string
};

export default Payment3x;
